// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2_wsv","dragIcon":"Choice_dragIcon__2N6RX","left":"Choice_left__2_rHB","input":"Choice_input__1I-iq"};